import { handleActions } from 'redux-actions-helpers'
import { InitialState } from './types'
import * as actions from './actions'

const initialState: InitialState = {
  userState: null,
  achievements: null,
  courses: null,
  isFetchingUserState: false,
  isFetchingAchievements: false,
  isFetchingCoursesList: false,
  isFetchingCourse: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchUserState]: state => {
      return {
        ...state,
        isFetchingUserState: true,
      }
    },
    [actions.fetchUserStateSuccess]: (state, action) => {
      return {
        ...state,
        userState: action.result,
        isFetchingUserState: false,
      }
    },
    [actions.fetchUserStateFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetchingUserState: false,
      }
    },
    [actions.fetchAchievements]: state => {
      return {
        ...state,
        isFetchingAchievements: true,
      }
    },
    [actions.fetchAchievementsSuccess]: (state, action) => {
      return {
        ...state,
        achievements: action.result,
        isFetchingAchievements: false,
      }
    },
    [actions.fetchAchievementsFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetchingAchievements: false,
      }
    },
    [actions.fetchCoursesList]: state => {
      return {
        ...state,
        courses: null,
        isFetchingCoursesList: true,
      }
    },
    [actions.fetchCoursesListSuccess]: (state, action) => {
      return {
        ...state,
        courses: action.result,
        isFetchingCoursesList: false,
      }
    },
    [actions.fetchCoursesListFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetchingCoursesList: false,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
